'use client';
import { classNames, Div, Text } from '@pezeshk-book/ui-kit';
import React from 'react';
import { MessagesProps } from './message-item.props';
import convertDate from '@utils/time/convert-date';
import { MessagesActions } from '@store/client/messages/messages-actions';
import { useDispatch } from 'react-redux';
import EyeIcon from '@icons-components/eye-icon';
import { useParams } from 'next/navigation';
import Button from '@elements/button';
import { LocaleTypes } from '@dictionaries-types';

const MessageItem = ({ dataRow }: MessagesProps) => {
  const dispatch = useDispatch();
  const sectionColor = dataRow?.read_at ? 'bg-control-50 border-control-300' : 'bg-tertiary-50 border-tertiary-300';
  const { lang } = useParams<{ lang : LocaleTypes }>();
  const handleReadAction = () => {
    dispatch(MessagesActions.setMessagesAsRead({ ids: [dataRow.id] }));
  };

  return (
    <Div
      className={classNames(
        'w-full flex flex-col p-4 rounded border border-opacity-50',
        sectionColor,
      )}
    >
      <Text typography={'sm'} color={'grey.800'} align={'right'}>
        {dataRow?.message?.content}
      </Text>
      <Div className={'items-center w-full justify-between'}>
        <Text className={'whitespace-nowrap'}>
          {convertDate(dataRow?.created_at, 'D MMMM YYYY ساعت HH:mm', lang)}
        </Text>
        {!dataRow?.read_at ? (
          <Button className={'!p-0'} shape={'square'} size={'small'} variant={'text'} onClick={handleReadAction}>
            <EyeIcon />
          </Button>
        ) : null}
      </Div>
    </Div>
  );
};
export default MessageItem;
